import { Box, Skeleton, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { ArrowUp, Box as BoxIcon, Clock, MinusCirlce } from "iconsax-react";
import { memo } from "react";

import type { DashboardStatCardProps, DashboardStatTrendTone } from "./DashboardStatCard.types";
import * as styles from "./DashboardStatCard.styles";

export type { DashboardStatCardProps } from "./DashboardStatCard.types";

function TrendIcon({ tone }: { tone: DashboardStatTrendTone }) {
  const theme = useTheme();

  if (tone === "success") {
    return <ArrowUp size={14} variant="Linear" color={theme.palette.success.main} />;
  }
  if (tone === "warning") {
    return <Clock size={14} variant="Linear" color={theme.palette.warning.main} />;
  }
  if (tone === "secondary") {
    return <BoxIcon size={14} variant="Linear" color={theme.palette.secondary.main} />;
  }
  return <MinusCirlce size={14} variant="Linear" color={theme.palette.text.disabled} />;
}

export const DashboardStatCard = memo(function DashboardStatCard({
  accent,
  value,
  label,
  icon,
  trendLabel,
  trendTone = "neutral",
  isLoading = false,
}: DashboardStatCardProps) {
  const isEmptyValue = value === "۰" || value === "0" || value === "—";

  return (
    <Box sx={styles.root(accent)}>
      <Box sx={styles.topRow}>
        <Box sx={styles.iconWrap(accent)} aria-hidden>
          {icon}
        </Box>
        {trendLabel ? (
          <Box sx={styles.trendBadge(trendTone)}>
            <TrendIcon tone={trendTone} />
            <Typography component="span" variant="caption" fontWeight={700}>
              {trendLabel}
            </Typography>
          </Box>
        ) : null}
      </Box>

      <Box sx={styles.valueBlock}>
        {isLoading ? (
          <Skeleton variant="text" width="55%" height={40} />
        ) : (
          <Typography sx={isEmptyValue ? styles.valueMuted : styles.value}>{value}</Typography>
        )}
        <Typography sx={styles.label}>{label}</Typography>
      </Box>
    </Box>
  );
});
